import OpenGraph from 'components/OpenGraph'
import Alert from 'cc/Alert'
import config from 'common/config'
import InstallExtensionButtonset from 'components/marketing/InstallExtensionButtonset'
import NewsletterForm from 'components/marketing/NewsletterForm'

const ExtensionPage = (props) => (
  <>
    <OpenGraph
      title="Extension Installation"
      description="Detailed instructions for installing the browser extension, bringing site ratings directly into your web browsing experience."
    />
    <div className="flex flex-col space-y-4">
      <Alert
        variant="warning"
        className="m-3 mx-5 md:mx-auto text-center md:w-1/2"
      >
        <Alert.Heading>PRE-ALPHA ACCESS ONLY</Alert.Heading>
        {config.appName} is currently in pre-alpha access. Welcome, but please
        be aware features are in active development and some may be broken.
      </Alert>
      {/* TODO: add per-browser instructions w/ personalized photos in e.g. images/ext/chrome */}

      <InstallExtensionButtonset hideLearnMore />
      <div className="h-20" />
      <div className="rounded-md bg-gray-100 flex justify-center items-center p-5">
        <NewsletterForm />
      </div>
    </div>
  </>
)

ExtensionPage.title = 'Extension Installation'
ExtensionPage.subtitle = 'Views on the voyd, directly in your browser'

export default ExtensionPage
